import sendToServer from './send-to-server';
import trackEvent from './track-event';

const CareerSuggestion = {
  init() {
    if (!($('.career-suggestion').length > 0)) return;
    trackEvent('Careers', 'completed', 'Diagnostic Quiz');
    $('.career').click(this.handleRecommendationClick.bind(this));

    $('.career').each((_, career) => {
      trackEvent('Careers', 'recommendation offered');
      sendToServer('/api/v2/events',
                 { event: 'saw_recommendation',
                   career_id: $(career).data('career-id') });
    });
  },

  handleRecommendationClick(event) {
    const $career = $(event.target).closest('.career');
    sendToServer('/api/v2/events',
                 { event: 'tried_recommendation',
                   career_id: $career.data('career-id') });
    trackEvent('Careers', 'recommendation accepted');
  },
};

$(document).ready(()=> {
  CareerSuggestion.init();
});
